<template>
  <div>
    <h1 class="subheading text-center mt-8" style="color: #f28a3e">
      Store - Operations
    </h1>
    <!-- Disha Section -->
    <div id="disha" class="team">
      <v-container>
        <v-container>
          <v-row>
            <v-col
              v-for="(item, index) in dishaItems"
              :key="index"
              cols="12"
              sm="6"
              md="4"
              lg="2"
            >
              <a
                :href="item.href"
                style="text-decoration: none; display: block; width: 100%"
              >
                <div class="tile-container tileCtr">
                  <div
                    class="icon-container iconCtr"
                    :style="{ backgroundColor: item.bgColor }"
                  >
                    <v-icon :style="{ color: item.iconColor, fontSize: '2.5rem' }">
                      {{ item.iconName }}
                    </v-icon>
                  </div>
                  <div
                  class="title-container titleCtr"
                  :style="{ color: item.iconColor }"
                >
                  {{ item.title }}
                </div>
                </div>
              </a>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
    </div>
    {{ authKey }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      authKey: localStorage.getItem("auth-key"),
      dishaItems: [
        {
          href: "https://spencers-visit.attabot.in/photo-sharing-event",
          title: "Events",
          iconName: "folder_shared",
          bgColor: "#EFEBE9",
          iconColor: "#6D4C41"
        },
        {
          href: "https://spencers-visit.attabot.in/notes",
          title: "Notes",
          iconName: "list",
          bgColor: "#E0F7FA",
          iconColor: "#00796B"
        },
        {
          href: "https://spencers-visit.attabot.in/barcodeScan",
          title: "OSA",
          iconName: "mdi-jira",
          bgColor: "#F3E5F5",
          iconColor: "#8E24AA",
        },
        {
          href: "https://spencers-visit.attabot.in/comments",
          title: "Comments",
          iconName: "chat",
          bgColor: "#FFF3E0",
          iconColor: "#FF7043"
        },
        {
          href: "https://spencers-visit.attabot.in/schedule",
          title: "Schedule",
          iconName: "cloud",
          bgColor: "#E8F5E9",
          iconColor: "#388E3C"
        },
        {
          href: "https://spencers-visit.attabot.in/vendorFeedbackReport",
          title: "NPS Vendor",
          iconName: "mdi-asterisk",
          bgColor: "#E3F2FD",
          iconColor: "#1976D2"
        },
        {
          href: "https://spencers-visit.attabot.in/nps",
          title: "Voice Of Customer",
          iconName: "person",
          bgColor: "#FCE4EC",
          iconColor: "#D81B60"
        },
        {
          href: "https://spencers-visit.attabot.in/petty-cash",
          title: "Petty Cash",
          iconName: "mdi-cash-multiple",
          bgColor: "#F1F8E9",
          iconColor: "#43A047"
        },
        {
          href: "https://spencers-visit.attabot.in/transaction-complain",
          title: "Transaction Complain",
          iconName: "mdi-cash-100",
          bgColor: "#E3F2FD",
          iconColor: "#1E88E5"
        },
        {
          href: "https://spencers-visit.attabot.in/pop",
          title: "POP",
          iconName: "print",
          bgColor: "#FFF8E1",
          iconColor: "#F9A825"
        },
        {
          href: "https://spencers-visit.attabot.in/contactUs",
          title: "Log Complain",
          iconName: "computer",
          bgColor: "#ECEFF1",
          iconColor: "#546E7A"
        }
      ]
    };
  }
};
</script>

<style>
html {
  height: 200%;
  scroll-behavior: smooth;
}

.tiles {
  background: #ffb6c1;
  transition: 0.3s ease-out 100ms;
  width: 150px;
  height: 150px;
}

.tiles:hover {
  cursor: pointer;
  background: #fae4d5 !important;
}

.tileCtr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 3px 8px;
  border-radius: 12px;
  padding: 20px;
  text-align: center;
  background-color: #fff;
  transition: background 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
}

.tileCtr:hover {
  cursor: pointer;
  transform: translateY(-5px);
  box-shadow: rgba(0, 0, 0, 0.2) 0px 8px 15px;
}

.iconCtr {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  margin-bottom: 10px;
  transition: transform 0.2s ease;
}

.iconCtr:hover {
  transform: rotate(10deg);
}

.titleCtr {
  font-size: 1rem;
  font-weight: bold;
  color: #333;
}
</style>
